import React, { createContext, useContext } from 'react';

import type { Platform, PlatformData } from 'src/app/pages/starterDashboardV2/shared/hooks';
import { useReadyToShare } from 'src/app/pages/starterDashboardV2/shared/hooks';
import type { ReadyToSharePostWithPlatform } from 'src/app/shared/api/readyToShare';

type ReadyToShareContextType = {
	data: {
		isOpen: boolean;
		shouldShowReadyToShareExperiment: boolean;
		isLoading: boolean;
		readyToSharePostsValue?: readonly ReadyToSharePostWithPlatform[];
		platformData: Record<Platform, PlatformData | undefined>;
	};
	actions: {
		openSharePreviewModal: () => void;
		closeSharePreviewModal: () => void;
		trackView: (currentPosition: string) => void;
	};
};

const ReadyToShareContext = createContext<ReadyToShareContextType | undefined>(undefined);

export const useReadyToShareContext = () => {
	const context = useContext(ReadyToShareContext);
	if (context === undefined) {
		throw new Error('useReadyToShareContext must be used within a ReadyToShareProvider');
	}
	return context;
};

export const ReadyToShareProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const readyToShare = useReadyToShare();
	return <ReadyToShareContext.Provider value={readyToShare}>{children}</ReadyToShareContext.Provider>;
};
